export async function fetchUrl(url) {
  return await (await fetch(url, { credentials: "include" })).json();
}

export async function fetchText(url) {
  return await (await fetch(url, { credentials: "include" })).text();
}
